export default function getMaxGuestCount(
  availableSpots: number = 0,
  participantsPerRegistration: number = 0,
  childrenPerRegistration: number = 0,
  childrenIncludedInCount: boolean = true
) {
  const availableGuestSpots = availableSpots - 1;
  const totalMax = participantsPerRegistration + childrenPerRegistration;

  if (availableGuestSpots > totalMax) {
    return {
      maxAdditionalGuests: participantsPerRegistration,
      maxAmountChildren: childrenPerRegistration,
    };
  } else if (participantsPerRegistration > availableGuestSpots) {
    return {
      maxAdditionalGuests: availableGuestSpots,
      maxAmountChildren: childrenIncludedInCount ? 0 : childrenPerRegistration,
    };
  } else {
    return {
      maxAdditionalGuests: participantsPerRegistration,
      maxAmountChildren: childrenIncludedInCount
        ? availableGuestSpots - participantsPerRegistration
        : childrenPerRegistration,
    };
  }
}
